import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { useMediaQuery } from "_common/component/MediaQueryProvider";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { useStores } from "_common/hooks";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faLeftLong } from "@fortawesome/free-solid-svg-icons";

const IEOMobile = observer(() => {
  const {
    authStore: { ieo },
  } = useStores();
  const { isMobile } = useMediaQuery();

  return (
    <>
      <div className="no_header">
        <Link to="/">
          <div className="fl allhg txtl">
            <FontAwesomeIcon
              icon={faLeftLong}
              className="bi bi-arrow-left fcf fw text-[24px]"
            />
          </div>
        </Link>

        <div className="fl allhg w-[80%] text-center leading-[50px]">
          <span className="fcf fzmmm">IEO</span>
        </div>

        <Link to="/">
          <svg
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
          >
            <path
              d="M914.9 158.4H183.5c-15.2 0-27.6-12.4-27.6-27.6v-4.1c0-15.2 12.4-27.6 27.6-27.6h731.4c15.2 0 27.6 12.4 27.6 27.6v4.1c0.1 15.2-12.3 27.6-27.6 27.6zM914.9 819.9H183.5c-15.2 0-27.6-12.4-27.6-27.6v-4.1c0-15.2 12.4-27.6 27.6-27.6h731.4c15.2 0 27.6 12.4 27.6 27.6v4.1c0.1 15.2-12.3 27.6-27.6 27.6zM574.7 489.2H176.6c-11.4 0-20.7-9.3-20.7-20.7v-18.1c0-11.4 9.3-20.7 20.7-20.7h398.1c11.4 0 20.7 9.3 20.7 20.7v18.1c0 11.4-9.3 20.7-20.7 20.7z"
              fill="#ffffff"
            />
          </svg>
        </Link>
      </div>
      <div className="oreimgbox">
        <div className="top-title-a">
          <div className="top-title-a-nfo">
            <p className="f18 fcf top-title-msg">Launchpad</p>
            <p className="f30 fcf wt80b">Mua sắm sớm đặc biệt với giá mới</p>
          </div>
        </div>
        <div className="top-title-b">
          <p className="f16 text-[#181818] mb-0">Launchpad</p>
          <p className="f14 text-[#444545] ">
            Cung cấp cơ hội đầu tư các dự án đầu tiên với chi phí thấp cho người
            dùng
          </p>
        </div>
      </div>
      <div className="issuebox">
        <div className="content">
          <FontAwesomeIcon icon={faInfoCircle} />
          <span className="fcc fzmmm">Hiện tại chưa có dự án đăng ký mua</span>
        </div>
      </div>
    </>
  );
});

export default IEOMobile;
